module.exports = __webpack_public_path__ + "img/VOLVO.b57a9907.svg";